// extracted by mini-css-extract-plugin
export default {"container":"container-cOmqT","notesContainer":"notesContainer-XX_fq","h4":"h4-gGDEi","p":"p-DAsfh","summaryNotes":"summaryNotes-Avmsv","title":"title-r71rE"};